import {
  FrontendContextV1,
  type FrontendProduct,
} from "@made-people/nestjs-bff-service";
import { RelatedProduct } from "@made-people/grease-product";
import { frontendProductToGreaseProduct } from "./frontend-product-to-grease-product";

export const frontendProductToGreaseRelatedProducts = (
  product: FrontendProduct,
  frontendContext: FrontendContextV1,
): RelatedProduct[] => {
  const relatedProducts = product.relatedProducts.map(
    (relatedProduct: FrontendProduct) => {
      return {
        relationType: relatedProduct.relation,
        product: frontendProductToGreaseProduct(
          relatedProduct,
          frontendContext,
        ),
      };
    },
  );

  return relatedProducts;
};
